/**
 * Copyright (c) 2024, Mohamed eRrais
 * mohamed@errais.net
 * محمد الرايس
 * Rais Digital Services
 * 
 * moshaf.akademy.ma/apps
 * from tajwyd.akademy.ma
*/

import axios from 'axios';
import {base} from '../Config/app';

const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJiaXNtaSI6Itio2ZDYs9uh2YXZkCDZsdmE2YTZh9mQINmx2YTYsdmR2Y7Yrduh2YXZjtmA2bDZhtmQINmx2YTYsdmR2Y7YrdmQ2YrZhdmQIiwiYWxhYW4iOiIyNC8wNy8yMDI0IC0g2KfZhNij2LHYqNi52KfYoSAxOCDZhdit2LHZhSAxNDQ2IiwiaWF0IjoxNzIxODM3ODQxfQ.OcdgPcQ6xtIhiqqGQ6lzQug6ccB4FFVNj3OnaNK64XE"

const Token = (app) => {
  const storage = localStorage.getItem(app)
  if(storage && JSON.parse(storage)?.token) {      
    return JSON.parse(storage).token
  }
  else {
    return token
  }
}

const Api = axios.create({
  //baseURL: `http://localhost:8024/`,  
  baseURL: base.api_url, 
  headers : {
    'Accept':'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bridge ${Token(base.name)}`,     // Finaly MeR 260106 1218  Bearer -> Bridge
  },
  service : base.name,
  domain: base.domain
})

async function Fetch(request, data, object=null, method='POST') {

	if(!request.startsWith('https')) {    
		let sub_url = ("/"+request).replace("//","/")
    request = Api.defaults.baseURL+sub_url
  }

	return new Promise(function (resolve, reject) {
		//alert(`${base.api_url} ${request} ${base.name} ${JSON.stringify(data)}`)
		fetch(request, {
			method: method,  
			headers: Api.defaults.headers,
			body: data && JSON.stringify(data) 
		}) 
		.then( async (response) => {
			if( [200,201,202].includes(response.status)) { 
				object && (object.style.borderColor ='green')
				resolve(response)
			}
			else {
        //console.log("Response", request, method, data, response); 
				object && (object.style.borderColor = 'orange')
        reject(response)
			}
		})
		.catch((error) => {
			//alert(`error ${JSON.stringify(error)}`) //console.log("Error", error, data)
			object && (object.style.borderColor = 'red')
			reject(error)			
		})
	})
}


const Read = (request, Items, Load=null, Message=null) => {
  Items([])
  //alert(`${request}...`)
  Api.get(request)
  .then(response => {
      //console.log('Api.Read', request, response.data);   alert(`${request} -> ${JSON.stringify(response.data)}`);
      Items(response.data)
      Load && Load(true)
  })
  .catch(error => {
      Message && Message(error)
      console.error('Error',request,error)
  })
}

const Delay = ms => new Promise(res => setTimeout(res, ms))

const Cookie = (key) => {
  const cookies = decodeURIComponent(document.cookie).split(';')
  cookies.forEach(c => {
    c = c.trim(); //console.log('cookie= ',c)
    if (c.indexOf(`${key}=`) === 0) {
      return c.substring(key.length+1, c.length) //; alert(`${key}= ${c} => ${value}`)
    }
  })
}

const IsExists = async (url, Message=null) => { 
  try { 
    const response = await fetch(url, { method: 'HEAD' }); 
    if (response.status === 200) { 
      return true;
    } 
    else { 
      Message && Message('File does not exist ?'); 
    } 
  } 
  catch (error) { 
    Message && Message(url+" "+error+"?")
  } 
}

export default Api
export {Fetch, Read, Cookie, Delay, IsExists}
